export const MuiInputAdornment = {
  styleOverrides: {
    root: {
      '& p': {
        fontWeight: 500,
      },
    },
  },
}
